import { SET_DATA } from './types'

const initialState = {
  activeTrackName: null,
  status: 'idle',
  completedTracks: [],
  cardProgress: {},
  branchProgress: {},
  visitFlags: {},
  autorunConsumed: {},
  tracks: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default reducer
